import React, { useEffect, useRef, useState } from 'react';
import "./Navbar.css";
import { bellgreen, bellicon, bellwhite, brandbell, brandheart, newIcon, searchIcon } from '../../assets/imagesPath';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PATHS from '../../routes/Paths';
import { userLogout } from '../../redux/AuthSlice';
import { toast } from 'react-toastify';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig/FirebaseConfig';
import { BASE_URL } from '../../services/ApiEndpoints';
import useUserSnapshot from '../customHooks/useUserSnapshot';
import { useGetNotificationsQuery, useInfluencerMainSearchQuery, useSeenNotificationMutation } from '../../services/Api';
import moment from 'moment/moment';
import useUpdateCount from '../customHooks/useUpdateCount';
import { useDebounce } from "use-debounce";

const BrandNavbar = () => {

    const [callApi, setCallaApi] = useState(false);
    const [name, setName] = useState("");
    const [debouncedName] = useDebounce(name, 300);
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const searchRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const auth = useSelector((data) => data?.auth);
    const currentUserId = auth?.userDetail?.UserId?.toString();
    const { notificationCount } = useUserSnapshot(currentUserId);
    const { updateCount } = useUpdateCount();

    const [seenNotification] = useSeenNotificationMutation();

    const {
        data: getNotifications,
        refetch: getNotificationsRefetch,
    } = useGetNotificationsQuery();

    const {
        // data: influencerMainSearch,
        refetch: influencerMainSearchRefetch,
        // loading: influencerMainSearchLoading,
    } = useInfluencerMainSearchQuery({ name: debouncedName });

    useEffect(() => {
        influencerMainSearchRefetch();
    }, []);

    useEffect(() => {
        if (callApi) {
            getNotificationsRefetch();
            setCallaApi(false);
        }
    }, [callApi]);

    const onSeenNotification = (id, value) => {
        const data = {
            notificationId: id,
        };

        const url = `${value?.Path}?id=${value?.Body?.challengeId}&tag=${value?.TAG}`;
        window.open(url, "_blank");

        // navigate(value?.Path, { state: { id: value?.Body?.challengeId, tag: value?.TAG } });

        seenNotification({ data: data })
            .unwrap()
            .then((payload) => {
                if (payload?.success) {
                    getNotificationsRefetch();
                } else {
                    toast.error(payload?.message);
                }
            })
            .catch((error) => {
                toast.error(error?.data?.message);
            });
    };

    const updateUserStatus = async (userId) => {
        const userRef = doc(db, 'users', userId);

        try {
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                await updateDoc(userRef, {
                    onlineStatus: false,
                    lastActive: new Date()
                });
                console.log("User status updated successfully.");
            } else {
                console.log("User does not exist.");
            }
        } catch (error) {
            console.error("Error updating user status:", error);
        }
    };

    const logoutHandler = () => {
        dispatch(userLogout(null));
        navigate(PATHS.home);
        updateUserStatus(auth?.userDetail?.UserId?.toString());
        toast.success("User logged out successfully");
    };

    const getRouteText = (pathname) => {
        switch (pathname) {
            case '/dashboard':
                return 'Overview';
            case '/find-influencers':
                return 'Find Influencers';
            case '/my-network':
                return 'My Network';
            case '/challenges':
                return 'Challenges';
            case '/hire-influencers':
                return 'Hire Influencer';
            case '/hired-influencers':
                return 'Hired Influencer';
            case '/brand-messages':
                return 'Messages';
            case '/emails':
                return 'Emails';
            case '/reports':
                return 'Reports';
            case '/brand-transactions':
                return 'Transactions';
            case '/settings':
                return 'Settings';
            case '/brand-support':
                return 'Help & Support';
            case '/brand-saved-influencers':
                return 'Saved Influencers';
            case '/challenges/proposals':
                return 'Challenges';
            default:
                return 'Overview';
        }
    };

    const routeText = getRouteText(location.pathname);

    useEffect(() => {
        const fetchData = async () => {
            if (debouncedName) {
                const { data } = await influencerMainSearchRefetch();
                const filteredData = data?.data?.influencers?.filter(data => data != null);

                setSearchResults(filteredData || []);
                setShowResults(true);
            } else {
                setSearchResults([]);
                setShowResults(false);
            }
        };
        fetchData();
    }, [debouncedName]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowResults(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className='d-flex align-items-center justify-content-between brandNav'>
            <h3 className='mb-0' style={{ fontSize: "2rem", fontWeight: "600", fontFamily: "Inter" }}>{routeText}</h3>

            <div className='d-flex align-items-center gap-4'>
                <div className="mainSearchbar position-relative" ref={searchRef}>
                    {/* <input type="text" placeholder="Search..." onChange={(e) => setName(e.target.value)} onFocus={() => searchResults.length > 0 && setShowResults(true)} />
                    <img src={searchIcon} alt="" className="searchIcon" height={16} /> */}

                    {showResults && (
                        <ul className="resultsList">
                            {searchResults?.length > 0 ? (
                                searchResults?.map((data, index) => (
                                    <li
                                        key={index}
                                        onClick={() => {
                                            navigate(PATHS.viewInfluencerDetail, { state: { id: data?.UserId } });
                                            setShowResults(false);
                                            setName("");
                                        }}
                                    >
                                        <img src={BASE_URL + data?.ProfilePic} alt="" className='rounded-circle me-2' height={25} width={25} style={{ objectFit: "cover" }} />
                                        {data?.FullName}
                                    </li>
                                ))
                            ) : (
                                <li className="text-center">No record found</li>
                            )}
                        </ul>
                    )}
                </div>
                <Link to={PATHS.brandSavedInfluencers}>
                    <img src={brandheart} alt="" height={32} width={32} />
                </Link>
                <div className="dropdown position-relative">
                    <a href="#" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        <div className="position-relative">
                            <img src={brandbell} alt="" height={32} width={32} onClick={() => { setCallaApi(true); updateCount(currentUserId, "notification") }} />
                            {notificationCount > 0 ?
                                <span className="badge">{notificationCount}</span>
                                : null}
                        </div>
                    </a>
                    <ul className="dropdown-menu customScroll border-0 p-0 notiDrop" aria-labelledby="dropdownMenuButton1" style={{ borderRadius: "1.8rem", right: "0", left: "unset !important", maxHeight: "30rem", overflow: "auto", boxShadow: "1px 2px 12px 0px #00000029", width: "40rem" }}>
                        <div className='d-flex align-items-center gap-3' style={{ borderBottom: "1px solid #E6E6E6", padding: "2rem 2.4rem" }}>
                            <img src={bellicon} height={15} width={15} alt="" />
                            <h2 className='mb-0' style={{ fontSize: "1.6rem", fontWeight: "500", fontFamily: "Inter" }}>Notifications ({notificationCount > 0 ? notificationCount : 0})</h2>
                        </div>
                        {getNotifications?.data?.map((data, index) => {
                            const timeAgo = moment(data?.createdAt).fromNow();
                            return (
                                <li key={index} onClick={() => onSeenNotification(data?.Id, data)} style={{ borderTop: "1px solid #E6E6E6", padding: "2rem" }}>
                                    <div className='d-flex align-items-start gap-3 cursor'>
                                        {/* <img src={notificationCount > 0 ? bellgreen : bellwhite} height={40} width={40} alt="" /> */}
                                        <img src={data?.Seen ? bellwhite : bellgreen} height={40} width={40} alt="" />
                                        <div className='w-100'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <h4 className="mb-0" style={{ fontSize: "1.4rem", fontWeight: "600", fontFamily: "Inter" }}>{data?.Title}</h4>
                                                {notificationCount > 0 ?
                                                    <img src={newIcon} height={24} width={38} alt="" />
                                                    : null}
                                            </div>
                                            <p className="mb-0" style={{ fontSize: "1.2rem", fontWeight: "400", fontFamily: "Inter", marginTop: ".2rem" }}>{data?.Message}</p>
                                            <p className="mb-0 text-end" style={{ fontSize: "1rem", fontWeight: "400", fontFamily: "Inter", marginTop: ".8rem" }}>{timeAgo}</p>
                                        </div>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>

                <div className="dropdown profileDropdown brandDrop">
                    <a href="#" id="dropdownMenuButton4" data-bs-toggle="dropdown" aria-expanded="false" style={{ textDecoration: "none" }}>
                        <div className='d-flex align-items-center'>
                            <span className='navCat'>{auth?.isLoggedIn && auth?.userDetail?.Role == "influencer" ? "Creator" : "Brand"}</span>
                            <img src={auth?.userDetail?.ProfilePic?.startsWith('https') ? auth?.userDetail?.ProfilePic : BASE_URL + auth?.userDetail?.ProfilePic} alt="" className="rounded-circle navProfImg" style={{ height: "4rem", width: "4rem", objectFit: "cover" }} />
                        </div>
                    </a>
                    <ul className="dropdown-menu p-3" aria-labelledby="dropdownMenuButton4" style={{ right: "unset !important", minWidth: "22rem" }}>
                        <li>
                            <div className="p-3 noLink">
                                <h4 className="mb-0">{auth?.userDetail?.FullName || "_"}</h4>
                                <p className="mb-0 fs-5">{auth?.userDetail?.PrimaryEmail}</p>
                            </div>
                            <hr />
                        </li>
                        <li>
                            <Link className="dropdown-item py-4" to={PATHS.settings}>
                                <h4 className="mb-0">Settings</h4>
                            </Link>
                            <hr />
                        </li>
                        <li>
                            <hr />
                            <Link className="dropdown-item py-4" to={PATHS.brandSupport}>
                                <h4 className="mb-0">Support & Help</h4>
                            </Link>
                            <hr />
                        </li>
                        <li>
                            <div className="p-3 cursor" onClick={logoutHandler}>
                                <h4 className="mb-0">Logout</h4>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
};

export default BrandNavbar;